import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=072f0265&scoped=true&"
import script from "./Passenger.vue?vue&type=script&lang=js&"
export * from "./Passenger.vue?vue&type=script&lang=js&"
import style0 from "./Passenger.vue?vue&type=style&index=0&id=072f0265&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072f0265",
  null
  
)

export default component.exports